// extracted by mini-css-extract-plugin
module.exports = {"bp-min-md":"(min-width: 800px)","venueTags":"VenueTags-module--venueTags--0e0b92"};